import { useNavigate } from 'react-router-dom';

import {
  useAppShell,
  useAppShellActions,
} from '@/data/context/AppShellContext';
import useGoBack from '@/data/hook/useGoBack';
import { ROUTES } from '@/utils/routes';

export default function useShellGoBack() {
  const navigate = useNavigate();
  const goBack = useGoBack();
  const { backTarget } = useAppShell();
  const { getPreviousPath } = useAppShellActions();

  return () => {
    if (!backTarget) return goBack(ROUTES.DASHBOARD.BASE);
    if (getPreviousPath() === backTarget.href) return navigate(-1);
    navigate(backTarget.href);
  };
}
